module.exports = __webpack_public_path__ + "img/1437485757.673e38bc.jpg";